import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = `${config.backendUrl}/sales-status/update-salesmargin`;

export const updateSalesMargin = createAsyncThunk(
  "financial/updateSalesMargin",
  async ({ quotationId, ProjectName, TypeService, salesmargin, QuotedValue, token }, { rejectWithValue }) => {
    try {
      // Flat req.body: backend expects const { quotationId, ProjectName, TypeService, salesmargin, QuotedValue, isMarginUpdated } = req.body;
      const body = {
        quotationId,
        ProjectName,
        TypeService,
        Salesmargin: salesmargin,
        QuotedValue,
        isMarginUpdated: true,
      };
      const response = await axiosInstance.put(
        BackendURL,
        body,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data; // { message, updatedProject, updatedLeadQuotedValue }
    } catch (error) {
      console.error("❌ Error updating sales margin:", error);
      return rejectWithValue(
        error.response?.data?.error || "Failed to update sales margin"
      );
    }
  }
);

const updateSalesMarginSlice = createSlice({
  name: "updateSalesMargin",
  initialState: {
    loading: false,
    success: false,
    error: null,
    updatedProject: null,
    updatedLeadQuotedValue: null,
    message: "",
  },
  reducers: {
    resetSalesMarginState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.updatedProject = null;
      state.updatedLeadQuotedValue = null;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateSalesMargin.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateSalesMargin.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.updatedProject = action.payload.updatedProject;
        state.updatedLeadQuotedValue = action.payload.updatedLeadQuotedValue;
        state.message =
          action.payload.message || "Sales margin updated successfully";
      })
      .addCase(updateSalesMargin.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || "Error updating sales margin";
      });
  },
});

export const { resetSalesMarginState } = updateSalesMarginSlice.actions;
export default updateSalesMarginSlice.reducer;
